import * as types from '../actions/action-types'

export function setGoBackToVehicleTest({ pathname, vin }) {
  sessionStorage.setItem(
    'goBackToVehicleTest',
    JSON.stringify({ pathname, vin }),
  )
  return {
    type: types.SET_GO_BACK_TO_VEHICLE_TEST,
    pathname,
    vin,
  }
}

export function resetGoBackToVehicleTest() {
  sessionStorage.removeItem('goBackToVehicleTest')
  return {
    type: types.RESET_GO_BACK_TO_VEHICLE_TEST,
  }
}
